interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function FeedbackForm({ value, onChange, disabled }: Props) {
  return (
    <div className="mt-6">
      <label
        htmlFor="feedback"
        className="block text-sm font-medium text-gray-300 mb-2"
      >
        Feedback (optional)
      </label>
      <textarea
        id="feedback"
        rows={4}
        className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none"
        placeholder="Add notes for the editor..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}
